import { createStore } from 'effector';

import createStorage from 'utils/factories/create-storage';

import { MyStore } from 'types/Store';

export const $global = createStore<MyStore>({});

export const storage = createStorage<MyStore>($global);
